module.exports = __webpack_public_path__ + "img/specials-btn.dc001ab.png";


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/specials-btn.png
// module id = 693
// module chunks = 0